import modular from 'modujs';
import * as modules from './modules';
import globals from './globals';
// import shared from './shared';
import { $html } from './utils/dom';
import { ENV, CSS_CLASS } from './config';

const app = new modular({
    modules,
});

function init() {
    globals();
    // shared();

    app.init(app);

    $html.classList.add(CSS_CLASS.LOADED, CSS_CLASS.READY);
    $html.classList.remove(CSS_CLASS.LOADING);

    if (ENV.IS_TOUCH) {
        $html.classList.add(CSS_CLASS.TOUCH);
    }

    if (navigator.userAgent.toLowerCase().indexOf('firefox') >= 0) {
        $html.classList.add('is-firefox');
    }

    window.addEventListener('resize', () => {
        if (window.matchMedia('(any-pointer:coarse)').matches) {
            $html.classList.add(CSS_CLASS.TOUCH);
        } else {
            $html.classList.remove(CSS_CLASS.TOUCH);
        }
    });
}

////////////////
// Execute
////////////////
window.addEventListener('load', () => {

    init();
    window.dispatchEvent(new Event("p-loaded"));
    
    setTimeout(() => {
        window.dispatchEvent(new Event("hide-loading"));
    }, 1000);

});
